<!--Vista de recuperación de contraseña
    En esta sección se ingresa el email del usuario del que desean recuperar la contraseña y posteriormente
    le llega un correo con un enlace para ingresar la nueva contraseña
-->
<template>
  <v-container fluid class="loginContainer primary">
    <v-row justify="center" align="center" class="loginWrapper">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="11" sm="7" md="5" lg="4" xl="3">
            <v-card class="px-8 pt-10">
              <v-form v-on:submit.prevent="validate" ref="form" v-model="valid" lazy-validation>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <h1 class="display-1 font-weight-bold">Recuperación de contraseña</h1>
                    <h2
                      class="title"
                    >Se te enviará un correo de confirmación al correo registrado.</h2>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      type="email"
                      ref="emailInput"
                      prepend-icon="fas fa-user"
                      v-model.trim="user.email"
                      :rules="[...emailRules, invalidUser]"
                      label="Correo electrónico"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="center" class="mb-3">
                      <v-btn
                        :loading="loading"
                        type="submit"
                        :disabled="!valid"
                        color="accent"
                        block
                        large
                        class="black--text font-weight-bold"
                      >Confirmar</v-btn>
                    </v-row>
                    <v-row justify="center" class="text-center">
                      <v-col cols="11" md="10" xl="9">
                        <p class="subtitle-1">
                          ¿Ya tienes una cuenta? 
                          <span
                            class="secondary--text font-weight-bold pointer"
                            @click="login()"
                          >Inicia sesión.</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" class="mt-10">
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
          <v-col cols="6" sm="4" md="3" lg="3" xl="2">
            <v-row justify="center">
              <v-img src="@/assets/logo-WC.png" width="100%" height="auto"></v-img>
            </v-row>
          </v-col>
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
//Validaciones
import { validations } from "@/helpers/validations.js";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    loading: false,
    valid: true,
    validEmail:true,
    emailRules: validations.emailValidation(),

    user: {
      email: ""
    }
  }),
  computed:{
    invalidUser(){
      return () => this.validEmail || "Correo electrónico invalido"
    }
  },
  methods: {
    ...mapActions("user", ["fetchDataUser"]),
    ...mapMutations("notifications", ["show"]),
    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        let result = await this.fetchDataUser(this.user.email);
        if (result.status) {
          await this.show({ text: result.message });
          this.login();
        } else {
          await this.show({ text: `El correo no se encontró en el sistema. 🔎`, color: 'yellow darken-3' });
          this.validEmail=false;
          this.$refs.form.validate();
          this.$refs.emailInput.focus();
          setTimeout( () =>{
            this.validEmail=true;
            this.$refs.form.validate();
          }, 2000)
        }
      }
      this.loading = false;
    },
    login() {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped>
.loginContainer {
  min-height: 95vh;
  width: 100vw;
}
.loginWrapper {
  min-height: 90vh;
  width: 100vw;
}
</style>